//export const URL_SERVICE = 'http://192.168.15.91:16370/api';
//export const URL_SERVICE = 'https://localhost:16370/api';
export const URL_SERVICE = 'https://dissipenodeagentes.amg.es:27398/api'
export const URL_LICEN = 'https://licencia.amg.es:27388/api/licensedir/';
export const CCODCLI = '4897';
export const LOCALE = 'es';